import { useEffect, useState } from "react";
import { FavoriteWithIdTracks } from "../types";

const useIsFavorite = (
  trackCode: string,
  favoriteTracks: FavoriteWithIdTracks,
  isLogged: boolean
) => {
  const [isFavorite, setIsFavorite] = useState<boolean>(false);
  const [favoriteId, setFavoriteId] = useState<number | null>(null);

  useEffect(() => {
    if (
      favoriteTracks &&
      Object.keys(favoriteTracks).includes(trackCode) &&
      isLogged
    ) {
      setIsFavorite(true);
      // eslint-disable-next-line security/detect-object-injection
      setFavoriteId(favoriteTracks[trackCode]);
    } else {
      setIsFavorite(false);
      setFavoriteId(null);
    }
  }, [trackCode, isFavorite, favoriteTracks, isLogged]);

  return { isFavorite, setIsFavorite, favoriteId };
};

export default useIsFavorite;
